import React, { useEffect, useState } from 'react';
import { Skeleton } from 'antd';
import { TrophyOutlined, FireOutlined } from '@ant-design/icons';
import api from '../../services/api';

const BRAND = '#25D366';
const BRAND_DARK = '#128C7E';
const BRAND_DARKER = '#075E54';

// Card destacado no dashboard mostrando XP + nivel + rank + progresso.
// Puxa /api/community/players/me/xp.
export default function PlayerXpCard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/community/players/me/xp')
      .then(r => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{ background: '#fff', borderRadius: 16, padding: 20, marginBottom: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
      <Skeleton active paragraph={{ rows: 2 }} />
    </div>
  );
  if (!data) return null;

  const color = data.level_color || BRAND;

  return (
    <div style={{
      background: `linear-gradient(135deg, ${BRAND_DARKER} 0%, ${BRAND_DARK} 60%, ${color} 100%)`,
      borderRadius: 16, padding: 20, marginBottom: 16, color: '#fff',
      position: 'relative', overflow: 'hidden',
      boxShadow: `0 8px 24px ${color}40`,
    }}>
      {/* Orb decorativo */}
      <div style={{
        position: 'absolute', top: -60, right: -60, width: 200, height: 200,
        borderRadius: '50%', background: color, opacity: 0.4, filter: 'blur(50px)',
        pointerEvents: 'none',
      }} />

      <div style={{ position: 'relative', display: 'flex', gap: 14, alignItems: 'center', marginBottom: 14 }}>
        <div style={{
          width: 56, height: 56, borderRadius: 14,
          background: 'rgba(255,255,255,0.18)', backdropFilter: 'blur(8px)',
          display: 'grid', placeItems: 'center', fontSize: 28,
          border: '1px solid rgba(255,255,255,0.25)', flexShrink: 0,
        }}>
          <TrophyOutlined />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 10, opacity: 0.9, letterSpacing: 1.5, fontWeight: 700 }}>NÍVEL {data.level}</div>
          <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: -0.5, lineHeight: 1.1 }}>{data.level_label}</div>
          <div style={{ fontSize: 12, opacity: 0.85, marginTop: 2 }}>
            <strong>{data.total_xp.toLocaleString('pt-BR')} XP</strong>
            {data.rank && ` · #${data.rank} no rank`}
          </div>
        </div>
        {/* Badge de streak (dias consecutivos) */}
        {data.streak_current > 0 && (
          <div title={`Recorde: ${data.streak_longest} dias`} style={{
            padding: '8px 12px', borderRadius: 12,
            background: 'rgba(255, 92, 51, 0.25)',
            border: '1px solid rgba(255,183,120,0.4)',
            backdropFilter: 'blur(6px)', textAlign: 'center',
            minWidth: 62, flexShrink: 0,
          }}>
            <div style={{ fontSize: 20, lineHeight: 1 }}>🔥</div>
            <div style={{ fontSize: 18, fontWeight: 900, marginTop: 2 }}>{data.streak_current}</div>
            <div style={{ fontSize: 9, opacity: 0.85, letterSpacing: 0.5, marginTop: 1 }}>
              {data.streak_current === 1 ? 'DIA' : 'DIAS'}
            </div>
          </div>
        )}
      </div>

      {/* Barra de progresso */}
      {data.next_level ? (
        <div style={{ position: 'relative' }}>
          <div style={{ fontSize: 11, opacity: 0.9, marginBottom: 6, display: 'flex', justifyContent: 'space-between' }}>
            <span>Rumo a <strong>{data.next_level.label}</strong></span>
            <span><FireOutlined /> {data.xp_to_next.toLocaleString('pt-BR')} XP</span>
          </div>
          <div style={{
            height: 10, borderRadius: 6, background: 'rgba(255,255,255,0.2)',
            overflow: 'hidden', boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.15)',
          }}>
            <div style={{
              width: `${data.progress_pct}%`, height: '100%',
              background: 'linear-gradient(90deg, #fff 0%, rgba(255,255,255,0.85) 100%)',
              borderRadius: 6, transition: 'width 0.6s',
              boxShadow: '0 0 8px rgba(255,255,255,0.5)',
            }} />
          </div>
        </div>
      ) : (
        <div style={{ position: 'relative', fontSize: 12, opacity: 0.9, textAlign: 'center', fontWeight: 600 }}>
          🏆 Nível máximo alcançado — você é lenda!
        </div>
      )}
    </div>
  );
}
